import { AssetsFileResolver } from 'app-modules/application/containers/AssetsFileResolver';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  badge: {
    height: '0.9rem',
    marginRight: theme.spacing.unit / 2,
  },
  chatName: {
    letterSpacing: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  points: {
    fontSize: '0.9rem',
    fontWeight: 'bold',
    opacity: 0.75,
    letterSpacing: 1,
    lineHeight: 1.5,
  },
  root: {
    borderRadius: theme.spacing.unit / 2,
  },
  winner: {
    backgroundColor: '#fffad6',
  },
});

const UserWithPointsComponent = ({ chatName, classes, className, isWinner, points, ...props }) => (
  <li {...props} className={classNames(className, classes.root, { [classes.winner]: isWinner })}>
    <Typography className={classes.chatName} variant="body1">
      {chatName}
    </Typography>
    <Typography className={classes.points} variant="overline">
      {isWinner && (
        <AssetsFileResolver
          alt="first place"
          className={classes.badge}
          path="images/firstPlace.png"
        />
      )}
      {points} PTS
    </Typography>
  </li>
);

UserWithPointsComponent.propTypes = {
  chatName: PropTypes.string.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  isWinner: PropTypes.bool.isRequired,
  points: PropTypes.number.isRequired,
};

export const UserWithPoints = withStyles(styles)(UserWithPointsComponent);
